import {useTitle} from 'hooks';
import {NavbarCommon} from 'components';
import FormSignIn from './components/Form.SignIn';

interface IPageSignInProps {}

const PageSignIn = ({}: IPageSignInProps) => {
  useTitle('Sign In');
  return (
    <div className="min-h-screen flex flex-col">
      <NavbarCommon />
      <FormSignIn />
    </div>
  );
};

export default PageSignIn;
